//Время (в мс), через которое будет отправляться запрос, на обновления данных
export const DATA_UPDATE_INTERVAL_SIZE = 1000 * 60;

//Отображать ли новый вид и функционал подписки?
export const SHOWED_NEW_SUBSCRIPTION = false;

//Отображать ли новые форкастеры?